import { parseISO, isWeekend } from 'date-fns';

export const countWorkingDays = (start: string, end: string): number => {
  const startDate = parseISO(start);
  const endDate = parseISO(end);
  let workingDaysCount = 0;

  for (
    let date = startDate;
    date <= endDate;
    date.setDate(date.getDate() + 1)
  ) {
    if (!isWeekend(date)) {
      workingDaysCount += 1;
    }
  }

  return workingDaysCount;
};

export const calculatePercentage = (part: number, whole: number): number => {
  if (whole === 0) {
    return 0; // Avoid division by zero
  }
  return parseFloat(((part / whole) * 100).toFixed(2));
};
